import React, { useState, useEffect } from 'react';
import { DERSLER } from '../../lib/dersler.js';

// HAFTA SÜZGECİ kapsam kutusu (TYMM Öğrenme Kanıtı, 2026-10-09): seçilen haftaya kadar
// yıllık planda TAMAMLANMIŞ öğrenme çıktıları ders başına (GET /api/kazanim/hafta-kapsami,
// kaynak prompts/master/MAARIF_YILLIK_PLAN_2026.json). Desteklenmeyen ders kırmızı uyarı:
// sunucu o istekte 400 `hafta_desteklenmiyor` döner. Aralık (2026-10-26): `haftaBas` > 1 ise kapsam
// bitişi [haftaBas, hafta] içinde olan ÖÇ'lerdir; daha önce bitenler `onceki` (sorulmaz).
export default function HaftaKapsami({ apiUrl, sinif, hafta, haftaBas = 1, dersler, cografyaSaat }) {
  const [veri, setVeri] = useState(null);
  const anahtar = dersler.join(',');
  useEffect(() => {
    if (!hafta || !anahtar) { setVeri(null); return undefined; }
    let iptal = false;
    const token = localStorage.getItem('yks_token');
    const qs = new URLSearchParams({ sinif: String(sinif), hafta: String(hafta), dersler: anahtar });
    if (cografyaSaat) qs.set('cografyaSaat', String(cografyaSaat));
    if (haftaBas > 1) qs.set('haftaBas', String(haftaBas));
    fetch(`${apiUrl}/api/kazanim/hafta-kapsami?${qs}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then(r => r.json())
      .then(d => { if (!iptal) setVeri(Array.isArray(d.kapsam) ? d.kapsam : null); })
      .catch(() => { if (!iptal) setVeri(null); });
    return () => { iptal = true; };
  }, [apiUrl, sinif, hafta, haftaBas, anahtar, cografyaSaat]);

  if (!veri) return null;
  const ad = (k) => (DERSLER.find(x => x.value === k)?.label || k).replace(/^(TYT|AYT)\s+/i, '');
  return (
    <div data-hafta-kapsam className="rounded-lg border border-emerald-200 bg-emerald-50/50 px-3 py-2 space-y-1">
      <div className="text-[11px] font-bold text-emerald-900">
        {haftaBas > 1
          ? `${haftaBas}-${hafta}. haftalar arasında tamamlanması gereken öğrenme çıktıları (2026 DÖP yıllık planı)`
          : `${hafta}. haftaya kadar işlenmiş olması gereken öğrenme çıktıları (2026 DÖP yıllık planı)`}
      </div>
      {veri.map(k => (k.destek ? (
        <details key={k.ders} data-hafta-ders={k.ders} className="text-[11px] text-gray-700">
          <summary className="cursor-pointer">
            <strong>{ad(k.ders)}</strong> · {k.tamam.length}/{k.oc_toplam} ÖÇ tamamlandı
            {k.son_oc ? <> · son: <span className="font-mono">{k.son_oc.kod}</span> {k.son_oc.ad}</> : ' · henüz tamamlanan ÖÇ yok'}
            {k.devam.length > 0 && <span className="text-gray-500"> · işlenmekte: {k.devam.map(o => o.kod).join(', ')} (sorulmaz)</span>}
            {Array.isArray(k.onceki) && k.onceki.length > 0 && <span className="text-gray-500"> · {haftaBas}. haftadan önce biten {k.onceki.length} ÖÇ sorulmaz</span>}
          </summary>
          <ul className="mt-1 ml-4 list-disc">
            {k.tamam.map(o => (
              <li key={`${o.tema}|${o.kod}`}><span className="font-mono">{o.kod}</span> {o.ad} <span className="text-gray-400">({o.bit}. hafta)</span></li>
            ))}
          </ul>
        </details>
      ) : (
        <div key={k.ders} data-hafta-desteklenmiyor={k.ders} className="text-[11px] text-red-700 font-semibold">⚠ {k.neden}</div>
      )))}
    </div>
  );
}
